import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';


const initializeBlock = function( $block ){
  // For backend, ensure we're targeting the actual block.
  if(!!$block[0]){
    $block = $block[0].firstElementChild;
  }

  if(!$block.splide){
    // First, Determine which block we're in, and set the args accordingly.
    let slider;
    let args = {};
    let type = 'slide';

    // Post Feed Slider
    if($block.classList.contains('post_feed')){
      // Only apply slider if post feed is set to slider.
      if($block.classList.contains('splide')){
        slider = $block;
    
        args = {
          gap: '8rem',
          perPage: 3, 
          perMove:3,
          arrows: false,
          pagination: false,
          autoplay: false,
          interval: 5000,
          pauseOnHover: true,
          keyboard: true,
          breakpoints: {
            1919: {
              perPage: 2,
              perMove: 2,
            },
            767: {
              perPage: 1,
              gap: '2rem'
            }
          }
        }
      }
    }

    // Quote Slider
    else if($block.classList.contains('quote_slider')){
      slider = $block;
      type = 'loop';

      args = {
        type : 'loop',
        gap: '4rem',
        perPage: 1, 
        perMove:1,
        arrows: false,
        pagination: true,
        autoplay: false,
        interval: 5000,
        pauseOnHover: true,
        keyboard: true,
        speed: 750,
        breakpoints: {
          767: {
            perPage: 1,
            gap: '2rem'
          }
        }
      }
    }

    // Default Slider Block
    else if(!!$block.querySelector('.slider_block__slider')){
      slider = $block.querySelector('.slider_block__slider');
    }

    if(slider){
      $block.splide = new Splide( slider, args );

      // Watch for custom nav button clicks and button states
      const navButtons = slider.querySelectorAll('.slider_nav__arrow');
      if(navButtons.length){
        const left = slider.querySelector('.slider_nav__arrow.left');
        const right = slider.querySelector('.slider_nav__arrow.right');

        if(type !== 'loop'){
          $block.splide.on('ready', () => {
            if($block.splide.index == 0){
              left.setAttribute('disabled', true);
            }
          });
          
          $block.splide.on( 'move', (newIndex, prevIndex, destIndex) => {
            const slidesPerPage = $block.splide.options.perPage;
      
            if(newIndex == 0){
              left.setAttribute('disabled', true);
            }
            else if(left.getAttribute('disabled')) {
              left.removeAttribute('disabled');
            }
      
            if(newIndex >= ($block.splide.length - slidesPerPage)){
              right.setAttribute('disabled', true);
            }
            else if(right.getAttribute('disabled')) {
              right.removeAttribute('disabled');
            }
          } );
        }

        // Add class to new slide imediately when it becomes active
        // as opposed to the default, which happens after the transition
        $block.splide.on( 'move', (newIndex, prevIndex, destIndex) => {
          const slides = $block.splide.Components.Slides.get();
          slides.forEach(slide => {
            slide.slide.classList.remove('is-active');
            
            if(slide.index == newIndex){
              slide.slide.classList.add('is-active');
            }
          });
        } );
        

        navButtons.forEach(el => {
          el.addEventListener('click', ()=>{
            if(el.classList.contains('left')){
              $block.splide.go( '<' );
            }
            else {
              $block.splide.go('>');
            }
          });
        });
      }

      // Mount the slider
      $block.splide.mount();

      // Add class when user is clicking on the slider
      const sliderInner = slider.querySelector('.splide__list');
      const grabbedClass = 'mousedown';
      sliderInner.addEventListener('mousedown', (e) => {
        if(!(e.target.matches("a") || e.target.closest("a"))){
          slider.classList.add(grabbedClass);
        }
      });

      sliderInner.addEventListener('mouseup', (e) => {
        if(slider.classList.contains(grabbedClass)){
          slider.classList.remove(grabbedClass);
        }
      });
    }
  }
  else if($block.splide) {
    $block.splide.refresh();
  }
}


// Initialize the slider on the front end
export const initializeSlider = function(){
  const sliders = document.querySelectorAll('.slider_block, .post_feed.splide, .quote_slider');
  Array.prototype.forEach.call(sliders, function(el, i){
    initializeBlock(el);
  });
};

export const initializeSliderEditor = function (){
  // Initialize dynamic block preview (editor).
  if( window.acf ) {
    window.acf.addAction( 'render_block_preview/type=slider', initializeBlock );
    window.acf.addAction( 'render_block_preview/type=post-feed', initializeBlock );
    window.acf.addAction( 'render_block_preview/type=quote-slider', initializeBlock );
  }
}


